import React, { useState, useEffect } from "react";
import { doGet,doDownloadExcel,doDelete,doPut } from "../services/api-service";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {getDataDoAssessment,getAssessmentDetail}  from "../actions";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Select from "react-select";
import Search from "@material-ui/icons/Search";
import Visibility from "@material-ui/icons/Visibility";
import TextField from "@material-ui/core/TextField";
import InputIcon from "@material-ui/icons/Input";

import ExpandMore from "@material-ui/icons/ExpandMore";

import ExpandLess from "@material-ui/icons/ExpandLess";
import IconButton from "@material-ui/core/IconButton";
import Print from "@material-ui/icons/Print";
import ActionButton from "../components/ActionButton";
import AddIcon from "@material-ui/icons/Add";
import TableFooter  from "@material-ui/core/TableFooter";
import TablePagination   from "@material-ui/core/TablePagination";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Delete from "@material-ui/icons/Delete";
import Refresh from '@material-ui/icons/Refresh';
import DeleteForever from "@material-ui/icons/DeleteForever";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const statusOptions = [{value:"1",label:"Started Score 0"},
                       {value:"2",label:"Completed By Staff Score 0"},
                       {value:"3",label:"Completed By Staff Score > 0"},
                       {value:"6",label:"Completed By Leader"},
                       {value:"7",label:"Disagree"},
                       {value:"4",label:"Finish Score  0"},
                       {value:"5",label:"Finish Score > 0"},    
                       ]


const PaAssessmentComponent = props => {
    const { classes } = props;

    const [dataTable, setDataTable] = useState([]);
    const [masterOptions, setMasterOptions] = useState([])
    const [periodeOptions, setPeriodeOptions] = useState([])
    const [expandFilter, setExpandFilter] = useState(false)
    const [selectedPaMaster, setSelectedPaMaster] = useState(null)
    const [selectedParticipants, setSelectedParticipants] = useState([])
    const [selectedPeriode, setSelectedPeriode] = useState(null)
    const [participantOptions, setParticipantOptions] = useState([])
    const [unitParticipantOptions, setUnitParticipantOptions] = useState([])
    const [selectedUnitParticipant, setSelectedUnitParticipant] = useState(null)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(1)
    const [totalRows, setTotalRows] = useState(0)
    const [filterParams, setFilterParams] = useState({})
    const [tobeDelete, setTobeDelete] = useState(0)
    const [tobeReset, setTobeReset] = useState(0)
    const [selectedStatus, setSelectedStatus] = useState(null)
    const [selectedAssessmentId, setselectedAssessmentId] = useState(null)
    
    const [atasans, setAtasans] = useState([])
    const [isDialogOpen, setDialogOpen] = useState(false);

    const [newEmpId, setNewEmpId] = useState('');
    const [showAddAtasanForm, setShowAddAtasanForm] = useState(false); // State untuk mengatur visibilitas form



    const doAssessment = ($assessmentUserId, $empId) => {
        props.getDataDoAssessment($assessmentUserId)

        props.history.push({
            pathname: "/pa/app/assessment/do/reprocess",
            state: { atasanId: $empId }
        });

    };
    
    // Fungsi untuk menambah atasan baru
    const handleAddAtasan = async () => {
        if (newEmpId) {
        
        const params={ emp_id: newEmpId, assessment_id:selectedAssessmentId }
        let response = await doPut("pa/assessment/add/atasan", params)

        if(response && response.data){
            setNewEmpId(''); // Kosongkan input setelah menambah
            setShowAddAtasanForm(false); // Sembunyikan form setelah atasan ditambah
            setDialogOpen(false)
            getData()
        }

        
        }
    };

    // Fungsi untuk toggle visibilitas form
    const handleShowAddAtasanForm = () => {
        setShowAddAtasanForm(!showAddAtasanForm);
    };

    const changePage=(event, newPage)=>{
        setPage(newPage+1)
        getData(newPage+1,filterParams)
    }

    const changeRowsPerPage = (event)=> {
        setRowsPerPage(+event.target.value);
        setPage(1);
    }

    const statusOnChange = (e) =>{
        setSelectedStatus(e)
    }

    useEffect(() => {
        getDataMaster()
        getDataPeriode()
        getDataParticipants()
        getData(page,filterParams)
        getDataUnit()
    }, []);

    useEffect(() => {
        getData(page,filterParams)
    }, [rowsPerPage])

    useEffect(() => {
        getData(page,filterParams)
    }, [isDialogOpen])

        const getDataMaster = async () =>{
        const params={}
        const response = await doGet("pa/master",params)
        if(response&&response.data&&response.data.length>0){
            const dataForSelect = response.data.map(master=>({value:master.id, label:`${master.name} - semester ${master.semester} - periode ${master.periode}`}))
            setMasterOptions(dataForSelect)
        }

    }

    const getDataPeriode = async () =>{
        const params={}
        const response = await doGet("pa/assessment/periodes",params)
        if(response&&response.data&&response.data.length>0){
            const dataForSelect = response.data.map(periode=>({value:periode, label:periode}))
            setPeriodeOptions(dataForSelect)
        }

    }

    const filter = async () => {
        const params = {
            participant_ids: selectedParticipants.length > 0 ? selectedParticipants.map(p=>(p.value)):null,
            master_id : selectedPaMaster!==null ? selectedPaMaster.value : null,
            unit_id : selectedUnitParticipant!==null ? selectedUnitParticipant.value : null,
            periode : selectedPeriode!==null ? selectedPeriode.value : null,
            status : selectedStatus!==null ? selectedStatus.value : null
        };
        setFilterParams(params)
        getData(page,params)
    };

    const getData = async (toPage, filterParams) =>{
        let params={
            page:toPage,
            rowsPerPage:rowsPerPage
        }

        if(filterParams)
        params = {...params, ...filterParams}

        const response = await doGet("pa/assessment", params);
        if(response && response.data){
            setDataTable(response.data.data)
            setPage(response.data.meta.current_page)
            setTotalRows(response.data.meta.total)
        }
    };

    const getDataParticipants = async () =>{
        const params={}
        const response = await doGet("user",params)
        if(response&&response.data&&response.data.length>0){
            const dataForSelect = response.data.map(emp=>({value:emp.emp_id, label:emp.emp_name}))
            setParticipantOptions(dataForSelect)
        }

    }

    const getDataUnit = async () =>{
        const params={}
        const response = await doGet("unit",params)
        if(response&&response.data&&response.data.length>0){
            const dataForSelect = response.data.map(unit=>({value:unit.unit_id, label:unit.unit_name}))
            setUnitParticipantOptions(dataForSelect)
        }

    }

    const toggleExpandFilter = ()=>{
        setExpandFilter(!expandFilter)
    }
    const unitParticipantOnChange = (e) =>{
        setSelectedUnitParticipant(e)
    }

    const participantsOnChange = (e) =>{
        setSelectedParticipants(e)
    }

    const periodeOnChange = (e) =>{
        setSelectedPeriode(e)
    }


    const masterOnChange = (e) =>{
        setSelectedPaMaster(e)
    }

    const goToDetail = (assessment_user_id) =>{

        // console.log("assessment_user_id", assessment_user_id)
        props.getAssessmentDetail(assessment_user_id)


        props.history.push("/pa/app/assessment/detail")
    }

    const exporting = (e) =>{
        const params = {
            file_name:"assessments",
            participant_ids: selectedParticipants.length > 0 ? selectedParticipants.map(p=>(p.value)):null,
            master_id : selectedPaMaster!==null ? selectedPaMaster.value : null,
            unit_id : selectedUnitParticipant!==null ? selectedUnitParticipant.value : null,
            periode : selectedPeriode!==null ? selectedPeriode.value : null
        };
        doDownloadExcel("pa/assessment/export/excel",params)
    }

    const confirmDelete = (data_id)=>{
        setTobeDelete(data_id)
    }

    const confirmReset= (item)=>{
        console.log(item)
        setTobeReset(item)
    }

    const deleteData = async()=>{
        const params={id:tobeDelete}
        await doDelete("pa/assessment",params)
        setTobeDelete(0)
        getData(page,filterParams)
    }

    const resetData = async()=>{
        const params={atasan_id:tobeReset?.emp_id, assesment_id:tobeReset?.assessment_id, flag:tobeReset?.owner}
        let response = await doPut("pa/assessment/reset/atasan", params)

        if(response && response.data){
            setTobeReset(0)
            // setAtasans(response.data.data)
            getData()
            setDialogOpen(false)
        }
    }





    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleCellClick = async (row) => {

        setAtasans(row.atasan_ids)

        setselectedAssessmentId(row.id)

        setDialogOpen(true);

        // let params={
        //     id:row.id,
        //     atasan_id: row.atasan_id
        // }

        // const response = await doGet(
        //     "pa/assessment/evaluator",
        //     params
        // );
        // if(response && response.data){

        //     if(response.data.message=='available'){
        //         setAtasans(response.data.data)
        //     }else{
        //         setAtasans(response.data.data)
        //     }

            // setDialogOpen(true);
            
        // } 
       
    };




    return (
        <React.Fragment>
            <Grid
                container
                spacing={8}
                direction="column"
                className={classes.container}
            >
                <Grid container direction="row" alignContent="flex-start">
                    <Grid item xs={10}>
                        <Typography
                            variant="h6"
                            gutterBottom
                            className="animated slideInLeft"
                        >
                            Assessment List
                        </Typography>
                    </Grid>

                    <Grid item xs={2} align="right">
                        <ActionButton
                            type="fab"
                            for={["adm"]}
                            role={props.user.role}
                            action={() =>
                                props.history.push("/pa/app/assessment/create")
                            }
                            icon={<AddIcon />}
                            color="secondary"
                            class={classes.fab}
                        />

                    </Grid>

                    <Grid container spacing={8} className={classes.filterContainer} >
                        <Grid item spacing={8} xs={9}container>
                            <Grid item xs={4}>
                                <Select
                                    options={masterOptions}
                                    value={selectedPaMaster}
                                    onChange={masterOnChange}
                                    placeholder="Select PA Master"
                                    isClearable
                                    />
                            </Grid>
                            <Grid item xs={4}>
                                <Select
                                    isClearable
                                    name="unit_participants"
                                    value={selectedUnitParticipant}
                                    onChange={unitParticipantOnChange}
                                    options={unitParticipantOptions}
                                    placeholder="Select Department"
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Select
                                    isMulti
                                    name="participants"
                                    value={selectedParticipants}
                                    onChange={participantsOnChange}
                                    options={participantOptions}
                                    placeholder="Select the participants"/>
                            </Grid>
                            {
                                expandFilter &&
                                <>
                                    <Grid item xs={4}>
                                        <Select
                                            options={periodeOptions}
                                            value={selectedPeriode}
                                            onChange={periodeOnChange}
                                            placeholder="Select periode"
                                            isClearable
                                            />
                                    </Grid>
                                    <Grid item xs={4}>
                                            <Select
                                                options={statusOptions}
                                                value={selectedStatus}
                                                onChange={statusOnChange}
                                                placeholder="Select Status"
                                                isClearable
                                            />

                                    </Grid>
                                    <Grid item xs={4}>

                                    </Grid>
                                </>
                            }

                        </Grid>
                        <Grid item xs={1}>
                            <IconButton onClick={toggleExpandFilter} color="primary"size="small" aria-label="toggleFilter">
                                    {!expandFilter && <ExpandMore fontSize="small"/>}
                                    {expandFilter &&<ExpandLess fontSize="small"/>}
                            </IconButton>
                        </Grid>

                        <Grid item xs={2} container justify="flex-end" alignItems="baseline">
                            <IconButton  onClick={filter} color="primary" aria-label="search">
                                <Search />
                            </IconButton>
                            <IconButton onClick={exporting} color="primary" aria-label="search">
                                <Print />
                            </IconButton>
                        </Grid>
                    </Grid>


                    <Grid item xs={12} className={classes.tableWrapper}>
                        <div className={classes.table}>
                            <Table>
                                <TableHead>
                                    <TableRow >
                                        <TableCell align="center">
                                            Owner
                                        </TableCell>
                                        <TableCell align="center">
                                            Assessment
                                        </TableCell>
                                        <TableCell align="center">
                                            Periode
                                        </TableCell>
                                        <TableCell align="center">
                                            Valid From
                                        </TableCell>
                                        <TableCell align="center">
                                            Valid Until
                                        </TableCell>
                                        <TableCell align="center">
                                            Status
                                        </TableCell>
                                        <TableCell align="center">
                                            total score
                                        </TableCell>
                                        <TableCell align="center">
                                            finalscore
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataTable.length > 0 &&
                                        dataTable.map(row => (
                                            <TableRow key={row.id} className={classes.table_row}>
                                                <TableCell align="left">
                                                    {row.owner_name}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.master_name}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.periode}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.valid_from}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.valid_until}
                                                </TableCell>
                                                <TableCell align="center"  onClick={() => handleCellClick(row)}>
                                                <span  style={{ cursor: 'pointer', color: 'blue' }}>
                                                    {row.status_value}
                                                </span>
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.total_score}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {row.score_category}
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid container wrap="nowrap" alignItems="center">
                                                    <ActionButton
                                                        title="detail"
                                                        type="icon-button"
                                                        for={["adm"]}
                                                        role={props.user.role}
                                                        action={() =>goToDetail(row.id)}
                                                        disabled={row.status === 0 || row.is_custom===0}
                                                        icon={<Visibility fontSize="small" />}
                                                    />

                                                   

                                                    <ActionButton
                                                            title="delete"
                                                            type="icon-button"
                                                            for={["adm"]}
                                                            role={props.user.role}
                                                            action={()=>confirmDelete(row.id)}
                                                            icon={<Delete />}
                                                    />   

                                                    <Dialog
                                                        open={tobeDelete!==0}
                                                        onClose={()=>setTobeDelete(0)}
                                                        aria-labelledby="alert-dialog-title"
                                                        aria-describedby="alert-dialog-description"
                                                    >
                                                        <DialogTitle id="alert-dialog-title">{"Delete confirmation ?"}</DialogTitle>
                                                        <DialogContent>
                                                        <DialogContentText id="alert-dialog-description">
                                                            Apakah anda yakin akan menghapus data tersebut ?
                                                        </DialogContentText>
                                                        </DialogContent>
                                                        <DialogActions>                                                        
                                                        <Button onClick={()=>deleteData()} color="secondary">
                                                            Delete
                                                        </Button>
                                                        <Button onClick={()=>setTobeDelete(0)} variant="contained" color="primary">
                                                            Cancel
                                                        </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                    
                                                    </Grid>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                                <TableFooter>
                                    <tr>
                                        <td colspan="10">
                                            <Grid container justify="flex-end">
                                                <Grid item>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    component="div"
                                                    count={totalRows}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page-1}
                                                    backIconButtonProps={{
                                                        "aria-label": "previous page",
                                                    }}
                                                    nextIconButtonProps={{
                                                        "aria-label": "next page",
                                                    }}
                                                    onChangePage={changePage}
                                                    onChangeRowsPerPage={changeRowsPerPage}
                                                />
                                                </Grid>
                                            </Grid>
                                        </td>
                                    </tr>

                                </TableFooter>
                            </Table>
                        </div>
                    </Grid>
                </Grid>
            </Grid>


            <Dialog
                open={isDialogOpen}
                onClose={handleCloseDialog}
                PaperProps={{
                style: {
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    minWidth: '50%',
                },
                }}
            >   
                {atasans && atasans.length > 0 ? (
                <DialogTitle>Daftar Yang Menilai</DialogTitle>
                  ):''}
              
                <DialogContent>



                <Button variant="outlined" color="primary" onClick={handleShowAddAtasanForm}>
          {showAddAtasanForm ? 'Cancel' : 'Add Atasan'}
        </Button>

        {/* Form input hanya muncul saat tombol "Add Atasan" diklik */}
        {showAddAtasanForm && (
          <>
            <TextField
              label="Tambah NIK Atasan"
              value={newEmpId}
              onChange={(e) => setNewEmpId(e.target.value)}
              fullWidth
              margin="normal"
            />
            <Button variant="contained" color="primary" onClick={handleAddAtasan}>
              Add Atasan
            </Button>
          </>
        )}
            
                {atasans && atasans.length > 0 ? (
                <Table>
                    <TableHead>
                    <TableRow>
                        <TableCell><b>NIK</b></TableCell>
                        <TableCell><b>NAMA</b></TableCell>
                        <TableCell><b>SUDAH MENILAI</b></TableCell>
                        <TableCell><b>RESET</b></TableCell>
                        <TableCell><b>REPROCESS</b></TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {atasans.map((row) => (
                        <TableRow key={row.emp_id}>
                        <TableCell>{row.emp_id}</TableCell>
                        <TableCell>{row.emp_name}</TableCell>
                        <TableCell>{row.sudah_menilai ? 'Sudah':'Belum'}</TableCell>
                        <TableCell>

                        <ActionButton
                            title="reset"
                            type="icon-button"
                            for={["adm"]}
                            role={props.user.role}
                            action={()=>confirmReset(row)}
                            icon={<Refresh />}
                        />   
                        


                        <Dialog
                            open={tobeReset!==0}
                            onClose={()=>setTobeReset(0)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Reset confirmation ?"}</DialogTitle>
                            <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Apakah anda yakin akan mereset data tersebut ?
                            </DialogContentText>
                            </DialogContent>
                            <DialogActions>                                                        
                            <Button onClick={()=>resetData()} color="secondary">
                                Reset
                            </Button>
                            <Button onClick={()=>setTobeReset(0)} variant="contained" color="primary">
                                Cancel
                            </Button>
                            </DialogActions>
                        </Dialog>


                        </TableCell>

                        <TableCell>

                        <ActionButton
                            title="enter"
                            type="icon-button"
                            for={["usr", "adm","ldr"]}
                            role={props.user.role}
                            action={() => doAssessment(selectedAssessmentId, row.emp_id)}
                            disabled={row.active === 0 || row.status_value==="expired"}
                            icon={<InputIcon fontSize="small" />}
                        />
                        </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
                ) : (
                <DialogTitle>Belum ada yang menilai</DialogTitle>
                )}


                 {/* Tombol untuk menampilkan form "Tambah Atasan" */}
        
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseDialog} color="primary">
                    Close
                </Button>
                </DialogActions>
            </Dialog>    


        </React.Fragment>
    );
};



const styles = theme => ({
    button_mini: {
        width: 30,
        height: 30,
        padding: 0
    },
    selectFilter: {
        marginTop: 5
    },
    container: {
        margin: -16
    },
    widthAction: {
        minWidth: 180
    },
    widthDate: {
        minWidth: 150
    },
    switchIcon: {
        height: 10,
        width: 10,
        color: "#ffffff"
    },
    fab: {
        marginTop: -30
    },
    tableWrapper: {
        
    },
    table: {
        border: "solid 1px RGB(204, 204, 204)",
        borderRadius: 5,
        display: "inline-block",
        width: "-webkit-fill-available",
        overflowX: "auto"
    },
    filterContainer:{
        marginBottom:10
    },
    table_row:{
        "&:hover": {
            backgroundColor: "#f2effd",
            color:"white"
          }
    }
});
const mapDispatchToProps = dispatch => {
    return {
        getDataDoAssessment : data => dispatch(getDataDoAssessment(data)),
        getAssessmentDetail : data => dispatch(getAssessmentDetail(data)),

    };
  }

const mapStateToProps = state => {
    return {
        user: state.user.user
    };
};
const PaAssessment = connect(mapStateToProps,mapDispatchToProps)(PaAssessmentComponent);
export default withRouter(withStyles(styles)(PaAssessment));
